import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import CategoryNav from '@/components/feature/CategoryNav';
import HeroBanner from './components/HeroBanner';
import HotComics from './components/HotComics';
import LatestUpdates from './components/LatestUpdates';
import RankingSection from './components/RankingSection';
import CategoryGrid from './components/CategoryGrid';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '韩国漫画网',
      url: 'https://www.koreancomic.cn/',
      description: '韩国漫画网提供海量免费韩漫在线阅读，每日更新最新热门作品，涵盖校园、恋爱、奇幻、热血等全品类题材。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.koreancomic.cn/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryNav />
        <HotComics />
        <LatestUpdates />
        <RankingSection />
        <CategoryGrid />
      </main>
      <Footer />
    </>
  );
}